import { Text } from "@clipboard-health/ui-components";
import { CollapsableAlert } from "@src/appV2/redesign/components/CollapsableAlert";
import { type ReactNode } from "react";

interface TimesheetReviewAlertProps {
  title: string;
  children: ReactNode;
}

/**
 * Presentational shell for the timesheet review alert. Variants live in
 * sibling files (e.g. `InShiftAdjustmentTimesheetReviewAlert`,
 * `PostShiftAdjustmentTimesheetReviewAlert`) and pass their own copy in.
 */
export function TimesheetReviewAlert(props: TimesheetReviewAlertProps) {
  const { title, children } = props;

  return (
    <CollapsableAlert title={title}>
      <Text variant="caption">{children}</Text>
    </CollapsableAlert>
  );
}
